export const componentProps = {
    content: {
        type: Object,
        required: false,
        default: () => ({}),
    },

    step: {
        type: String,
        required: false,
        default: '',
    },
};
